import axios from 'axios';
import _ from 'lodash';

import BaseModel from './BaseModel';
import UserModel from './UserModel';
const BASE = BaseModel.getApiBasePath() + '/api/v1/fleximodo/messages';

export default new class UrbioticaMessagesModel {

  constructor() { }

  get(serialNumber) {
    return new Promise((resolve, reject) => {
      this.getAll()
        .then((data) => {
          resolve(_.find(data.message, { serialNumber: serialNumber }));
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  getAll(dateFrom = null, dateTo = null) {

    const filter = {
      timestamp: {
        $gte: dateFrom,
        $lte: dateTo
      }
    };
    return new Promise((resolve, reject) => {
      axios.get(BASE, {
        params: {
          access_token: UserModel.getAccessToken(),
          filter: filter
        }
      })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

}


// WEBPACK FOOTER //
// ./src/components/FleximodoMessagesModel.js